import type { Client } from "urql";

import { TanStackDevtools } from "@tanstack/react-devtools";
import { formDevtoolsPlugin } from "@tanstack/react-form-devtools";
import {
  HeadContent,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import { NavigationProgress } from "@/components/navigation-progress";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { GeneralError } from "@/features/errors/general-error";
import { NotFoundError } from "@/features/errors/not-found-error";

interface RouterContext {
  urqlClient: Client;
  userId: string;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  errorComponent: GeneralError,
  notFoundComponent: NotFoundError,
  component: () => {
    return (
      <>
        <HeadContent />
        <NavigationProgress />
        <TooltipProvider>
          <Outlet />
        </TooltipProvider>
        <Toaster closeButton expand={false} richColors />
        {__NODE_ENV__ === "development" && (
          <TanStackDevtools
            config={{
              position: "bottom-right",
            }}
            plugins={[
              {
                name: "Tanstack Router",
                render: <TanStackRouterDevtoolsPanel />,
              },
              formDevtoolsPlugin(),
            ]}
          />
        )}
      </>
    );
  },
  head: () => ({
    meta: [
      {
        title: "See It Send It",
      },
    ],
  }),
});
